import React from 'react';
import {Helmet} from "react-helmet";

export default class NotFound extends React.Component {

    render() {

        return (<>
          <Helmet><meta name="robots" content="noindex" /></Helmet>
          <div style={{
            "width": "100px",
            "height": "100px",
            "position": "absolute",
            "top": "0",
            "left": "0",
            "right": "0",
            "bottom": "0",
            "margin": "auto",
            "fontSize": "60px"
          }}>
              {this.props.message ? this.props.message : '404'}
          </div>
        </>)
    }
}
